import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '../IconButton';
import { HeaderActions, HeaderContainer, HeaderInfo, HeaderTitle } from './styles';

export interface HeaderProps {
  title?: string;
  isSidebarOpen: boolean;
  isExpanded: boolean;
  showNewChat: boolean;
  onToggleSidebar: () => void;
  onNewChat: () => void;
  onToggleExpanded: () => void;
  onClose: () => void;
}

/** "Chat AI / Header" do Figma. */
export const Header: FC<HeaderProps> = ({
  title,
  isSidebarOpen,
  isExpanded,
  showNewChat,
  onToggleSidebar,
  onNewChat,
  onToggleExpanded,
  onClose
}) => {
  const { t } = useTranslation('activities');

  return (
    <HeaderContainer>
      <HeaderInfo>
        <IconButton
          icon="sidebarToggle"
          label={isSidebarOpen ? t('aiChat.closeSidebar') : t('aiChat.openSidebar')}
          onClick={onToggleSidebar}
        />
        {showNewChat && (
          <IconButton icon="newChat" label={t('aiChat.newChat')} onClick={onNewChat} />
        )}
        {title && <HeaderTitle title={title}>{title}</HeaderTitle>}
      </HeaderInfo>
      <HeaderActions>
        <IconButton
          icon={isExpanded ? 'contract' : 'expand'}
          label={isExpanded ? t('aiChat.collapse') : t('aiChat.expand')}
          onClick={onToggleExpanded}
        />
        <IconButton icon="close" label={t('aiChat.close')} onClick={onClose} />
      </HeaderActions>
    </HeaderContainer>
  );
};
